import React from 'react';
import { MDBContainer, MDBCard, MDBCardBody, MDBIcon, MDBRow, MDBCol, MDBCardText  } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Header from './ComponentFragments/Header';
import CampaignGraph from './ComponentFragments/CampaignGraph';


export default class DashboardNSF extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            campaign: '',
            type: '',
            labels: [],
            data1: [],
            data2: [],
            dataPoints: []
        }
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.formatter = new Formatter();
        this.props.loaderOff();
        this.getGraphData = this.getGraphData.bind(this);
    }

    async componentWillMount() {
        var _this = this;
        this.getGraphData();
        setInterval(function () {
            _this.getGraphData();
		}, 5000);
    }

    async getGraphData() {
        this.props.showHideCart(true);
        let dataLayer = new DataLayer();

        await dataLayer.Get('/distributor/getgraphdata').then((response) => {
            var ttstst = "";
            let lbls = [];
            let d1 = [];
            let d2 = [];
            let dataPoints = [];
            let colors = ['#CB3434', '#F39E49', '#F149F3', '#49F3B5', '#F3F149', '#9C49F3', '#4987F3', '#F349A0', '#6049F3', '#6ADB00']
            let cIndex = 0;
            response.data.graphDataList.forEach((item) => {
                lbls.push(item.shipName);
                d1.push(item.perc);
                d2.push(item.metric);
                if (item.perc <= 10) {
                    cIndex = 0;
                } else if (item.perc > 10 && item.perc <= 20) {
                    cIndex = 1;
                } else if (item.perc > 20 && item.perc <= 30) {
                    cIndex = 2;
                } else if (item.perc > 30 && item.perc <= 40) {
                    cIndex = 3;
                } else if (item.perc > 40 && item.perc <= 50) {
                    cIndex = 4;
                } else if (item.perc > 50 && item.perc <= 60) {
                    cIndex = 5;
                } else if (item.perc > 60 && item.perc <= 70) {
                    cIndex = 6;
                } else if (item.perc > 70 && item.perc <= 80) {
                    cIndex = 7;
                } else if (item.perc > 80 && item.perc <= 90) {
                    cIndex = 8;
                } else if (item.perc > 90) {
                    cIndex = 9;
                }
                let dp = {
                    y: item.perc,
                    label: item.shipName,
                    color: colors[cIndex],
                    indexLabelFormatter: function (e) { return e.dataPoint.y + '%'; } 
                };
                dataPoints.push(dp);
            });
            this.setState({
                campaign: response.data.campaign,
                type: response.data.type,
                labels: lbls,
                data1: d1,
                data2: d2,
                dataPoints: dataPoints
            })
        })
    }

    render() {
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let headerText = this.state.campaign;
        let subHeaderText = "(Based on - " + this.state.type + ")";
        return (
            <MDBContainer fluid>
                <Header headerText={headerText}
                    hideSearch={true}
                    subHeaderText={subHeaderText}
                />
                <br />
                <div >
                <CampaignGraph labels={this.state.labels} data1={this.state.data1} data2={this.state.data2} dataPoints={this.state.dataPoints}/>
                    </div>

            </MDBContainer>
        );
    }
}